/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargePoint } from '../../models/charge-point';

export interface GetChargePoint$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected charge point
 */
  chargePointUid: string;
}

export function getChargePoint(http: HttpClient, rootUrl: string, params: GetChargePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargePoint>> {
  const rb = new RequestBuilder(rootUrl, getChargePoint.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('chargePointUid', params.chargePointUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargePoint>;
    })
  );
}

getChargePoint.PATH = '/stations/{uid}/chargepoints/{chargePointUid}';
